import { Checkbox } from '@material-ui/core';
import React, { useState } from 'react';
import {
  Row,
  Col,
  Input,
  Button,
} from 'reactstrap';

const CATEGORY_PRESENTATION = {
  SMALL: 'SMALL',
  AVERAGE: 'AVERAGE',
  BIG: 'BIG',
};

const ModifyingCategoryButtons = ({
  onValidate,
  onCancel,
  showCancel,
}) => {
  const [saving, setSaving] = useState(false);
  return (
    <Row style={styles.categoryButtonsContainer}>
      <Col style={styles.centeredRow}>
        <Button
          color="primary"
          type="button"
          onClick={async () => {
            setSaving(true);
            await onValidate();
            setSaving(false);
          }}
        >
          {saving ? 'Saving...' : 'Save'}
        </Button>
      </Col>
      {showCancel && (
        <Col style={styles.centeredRow}>
          <Button
            color="danger"
            type="button"
            onClick={onCancel}
          >
            Cancel
          </Button>
        </Col>
      )}
    </Row>
  );
};

const CategoryInfos = ({
  category,
  categoriesArray,
  onChangeCategoryPosition,
  index,
  modifying = false,
  onEndModify,
  onCancelModify,
  style,
  isSubCategory,
}) => {
  const [categoryInUse, setCategoryInUse] = useState(
    category
    || {
      hidden: false,
      isExcludeRandom: false,
      pinned: false,
    },
  );

  const cancelModify = () => {
    setCategoryInUse(category || {});
    onCancelModify();
  };

  const updateCategoryInfo = (value, type) => {
    switch (type) {
      case '_id':
        setCategoryInUse({
          ...categoryInUse,
          _id: value,
        });
        break;
      case 'titleEn':
        setCategoryInUse({
          ...categoryInUse,
          titleEn: value,
        });
        break;
      case 'titleFr':
        setCategoryInUse({
          ...categoryInUse,
          titleFr: value,
        });
        break;
      case 'position':
        setCategoryInUse({
          ...categoryInUse,
          position: value,
        });
        break;
      case 'hidden':
        setCategoryInUse({
          ...categoryInUse,
          hidden: value,
        });
        break;
      case 'pinned':
        setCategoryInUse({
          ...categoryInUse,
          pinned: value,
        });
        break;
      case 'isExcludeRandom':
        setCategoryInUse({
          ...categoryInUse,
          isExcludeRandom: value,
        });
        break;
      case 'presentation':
        setCategoryInUse({
          ...categoryInUse,
          presentation: value,
        });
        break;
      default:
        console.log(`error updating field ${type} in new category`);
    }
  };

  return (
    <div style={style}>
      <Row>
        <Col>
          <h6>id:</h6>
        </Col>
        <Col>
          {(modifying && category === undefined)
            ? (
              <Input
                type="text"
                name="categoryId"
                value={categoryInUse._id}
                onChange={(evt) => updateCategoryInfo(evt.target.value, '_id')}
              />
            )
            : (<div>{categoryInUse._id}</div>)}
        </Col>
      </Row>
      <Row>
        <Col>
          <h6>titleEn: </h6>
        </Col>
        <Col>
          {(modifying)
            ? (
              <Input
                type="text"
                name="categoryTitleEn"
                value={categoryInUse.titleEn}
                onChange={(evt) => updateCategoryInfo(evt.target.value, 'titleEn')}
              />
            )
            : (<div>{categoryInUse.titleEn}</div>)}
        </Col>
      </Row>
      <Row>
        <Col>
          <h6>titleFr: </h6>
        </Col>
        <Col>
          {(modifying)
            ? (
              <Input
                type="text"
                name="categoryTitleEn"
                value={categoryInUse.titleFr}
                onChange={(evt) => updateCategoryInfo(evt.target.value, 'titleFr')}
              />
            )
            : (<div>{category.titleFr}</div>)}
        </Col>
      </Row>
      <Row>
        <Col>
          <h6>placement: </h6>
        </Col>
        <Col>
          <Input
            type="select"
            name="placement"
            value={index || categoryInUse.position || 0}
            onChange={(evt) => {
              if (modifying && category === undefined) {
                updateCategoryInfo(evt.target.value, 'position');
              } else {
                onChangeCategoryPosition(evt.target.value);
              }
            }}
          >
            <option style={styles.inputOptions}> </option>
            {categoriesArray.map((value, subIndex) => (
              <option value={subIndex} key={value._id}>{subIndex + 1}</option>
            ))}
          </Input>
        </Col>
      </Row>
      {(isSubCategory) && (
        <Row>
          <Col>
            <h6>Show in filters list? </h6>
          </Col>
          <Col>
            {(modifying)
              ? (
                <Checkbox
                  checked={!categoryInUse.hidden}
                  onChange={(_, checked) => updateCategoryInfo(!checked, 'hidden')}
                />
              )
              : (<div>{category.hidden ? 'yes' : 'no'}</div>)}
          </Col>
        </Row>
      )}
      {(isSubCategory) && (
        <Row>
          <Col>
            <h6>Pin Category? </h6>
          </Col>
          <Col>
            {(modifying)
              ? (
                <Checkbox
                  checked={categoryInUse.pinned}
                  onChange={(_, checked) => updateCategoryInfo(checked, 'pinned')}
                />
              )
              : (<div>{category.pinned ? 'yes' : 'no'}</div>)}
          </Col>
        </Row>
      )}
      {(isSubCategory) && (
        <Row>
          <Col>
            <h6>Include in random feed? </h6>
          </Col>
          <Col>
            {(modifying)
              ? (
                <Checkbox
                  checked={!categoryInUse.isExcludeRandom}
                  onChange={(_, checked) => updateCategoryInfo(!checked, 'isExcludeRandom')}
                />
              )
              : (<div>{category.isExcludeRandom ? 'yes' : 'no'}</div>)}
          </Col>
        </Row>
      )}
      {(isSubCategory) && (
        <Row>
          <Col>
            <h6>presentation: </h6>
          </Col>
          <Col>
            {(modifying)
              ? (
                <Input
                  type="select"
                  name="presentation"
                  value={categoryInUse.presentation || CATEGORY_PRESENTATION.AVERAGE}
                  onChange={(evt) => {
                    updateCategoryInfo(evt.target.value, 'presentation');
                  }}
                >
                  <option style={styles.inputOptions}> </option>
                  {Object.values(CATEGORY_PRESENTATION).map((value) => (
                    <option value={value} key={value}>{value}</option>
                  ))}
                </Input>
              )
              : (<div>{categoryInUse.presentation || CATEGORY_PRESENTATION.AVERAGE}</div>)}
          </Col>
        </Row>
      )}
      {(modifying) && (
        <ModifyingCategoryButtons
          onValidate={() => onEndModify(categoryInUse)}
          onCancel={cancelModify}
          showCancel={!categoryInUse._id}
        />
      )}
    </div>
  );
};

const styles = {
  inputOptions: {
    display: 'none',
  },
  categoryButtonsContainer: {
    marginTop: 15,
  },
  centeredRow: {
    display: 'flex',
    justifyContent: 'center',
  },
};

export default CategoryInfos;



// WEBPACK FOOTER //
// ./src/components/templates-manager/categories-components/CategoryInfos.js